import { GoogleServiceStatus } from '@/services/google-connections/types';

// A reconnect keeps the old grant active while the new consent is pending, so
// "connected" alone would settle before the user finishes on Google's screen.
export const isGoogleConsentSettled = (row?: GoogleServiceStatus) =>
  row?.status === 'connected' && !row.pending_authorization;
